import { FC } from "react";
import { BOMItem } from "../../../../../http/lock_calculator/types";
import styles from "../../LockCalculator.module.css";
import { BomConnectionCountField } from "./BomConnectionCountField";
import { BomHeaderLockField } from "./BomHeaderLockField";
import { BomTable } from "./BomTable";

type Props = {
  /** Rows are calculated by the backend and are the BOM source of truth. */
  items?: BOMItem[] | null;
  readOnly?: boolean;
  isAdmin?: boolean;
  onOpenHelp?: (text: string, image?: string) => void;
};

/** Composes the BOM input with the server-derived BOM presentation. */
export const BomSection: FC<Props> = ({ items, readOnly = false, isAdmin = false, onOpenHelp }) => (
  <div className={styles.tabTableWrapper}>
    <BomConnectionCountField readOnly={readOnly} onOpenHelp={onOpenHelp} />
    <BomHeaderLockField readOnly={readOnly} isAdmin={isAdmin} onOpenHelp={onOpenHelp} />
    <BomTable items={items} />
  </div>
);
